// extracted by mini-css-extract-plugin
export var actionButton = "_sl-0";
export var actionMenuContainer = "_sl-i";
export var bubble = "_sl-2";
export var bubbleActionMenu = "_sl-j";
export var bubbleContext = "_sl-6";
export var bubbleItems = "_sl-7";
export var customer = "_sl-3";
export var divider = "_sl-8";
export var fileList = "_sl-9";
export var hiddenComment = "_sl-o";
export var infoAbove = "_sl-a";
export var internal = "_sl-4";
export var lightActionButton = "_sl-1";
export var link = "_sl-b";
export var merchant = "_sl-5";
export var message = "_sl-c";
export var profilePicture = "_sl-e";
export var quillToolbarContainer = "_sl-f";
export var senderDate = "_sl-g";
export var senderDateCustomer = "_sl-h";
export var senderName = "_sl-d";
export var time = "_sl-k";
export var uploadedImage = "_sl-l";
export var username = "_sl-m";
export var xsmall = "_sl-n";